import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconThumbsUp({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.845 7.535a.47.47 0 0 0-.174.196l-1.618 3.251a.506.506 0 0 0-.053.225v5.288h5.642c.246 0 .457-.18.495-.425l.857-5.603H13.59c-.628 0-1.07-.561-1-1.149.053-.432.063-.86-.033-1.197-.088-.305-.251-.513-.583-.61-.033-.008-.073-.008-.13.024zM7 15.993c0 .277.224.502.5.502H9v-4.52H7.5c-.276 0-.5.224-.5.502v3.516zm10.99-5.414-.865 5.643a1.503 1.503 0 0 1-1.483 1.278H7.5c-.828 0-1.5-.675-1.5-1.507v-3.517c0-.832.672-1.507 1.5-1.507h1.52c.025-.15.07-.298.138-.436l1.618-3.252c.233-.466.795-.932 1.475-.735.726.21 1.104.73 1.267 1.297.153.538.122 1.131.066 1.596a.03.03 0 0 0 .006.022v.001h3.445a.967.967 0 0 1 .954 1.117z" fill={fill}/>
        </svg>
    );
}

export default IconThumbsUp;
